// import { PluginAPI } from '@vue/cli-service'
import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/helpers/api'
// import VueCookie from 'vue-cookie'
import content from '@/store/modules/content'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    content,
  },
  state: {
    cookies: {},
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    drawer: null,
    currentUserProfile: null,
    contentLibrary: null,
    userProfiles: null,
    totalClassSessions: 0,
    activeClassUsers: 0,
    classTrainingMinutes: 0,
    newClassUsers: 0,
    accounts: [],
    phoneNumberVerificationId: null,
    loginResolver: null,
    authUserId: null,
    busy: false,
  },
  mutations: {
    SET_COOKIE (state, { name, value }) {
      Vue.set(state.cookies, name, value)
    },
    REMOVE_COOKIE (state, name) {
      Vue.delete(state.cookies, name)
    },
    SET_BUSY (state, payload) {
      state.busy = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_AUTH_USER_ID (state, payload) {
      state.authUserId = payload
    },
    SET_LOGIN_RESOLVER (state, payload) {
      state.loginResolver = payload
    },
    SET_PHONE_NUMBER_VERIFICATION_ID (state, payload) {
      state.phoneNumberVerificationId = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_CURRENT_USER_PROFILE (state, payload) {
      // console.log('set current user profile', payload)
      state.currentUserProfile = payload
    },
    SET_CONTENT_LIBRARY (state, payload) {
      state.contentLibrary = payload
    },
    SET_USER_PROFILES (state, payload) {
      state.userProfiles = payload
    },
    SET_TOTAL_CLASS_SESSIONS (state, payload) {
      state.totalClassSessions = payload
    },
    SET_ACTIVE_CLASS_USERS (state, payload) {
      state.activeClassUsers = payload
    },
    SET_CLASS_TRAINING_MINUTES (state, payload) {
      state.classTrainingMinutes = Math.ceil(payload / 60)
    },
    SET_NEW_CLASS_USERS (state, payload) {
      state.newClassUsers = payload
    },
    SET_ACCOUNTS (state, accounts) {
      state.accounts = accounts
    },
  },
  actions: {
    async fetchContent (context) {
      if (!this.state.contentLibrary) {
        context.commit('SET_CONTENT_LIBRARY', await api.getContents())
      }
    },
    async fetchUserProfiles (context, userAuthId) {
      if (!this.state.userProfiles) {
        context.commit('SET_USER_PROFILES', await api.getUsersByAuthID(userAuthId))
      }
    },
    async fetchUserProfilesByEmail (context, email) {
      if (!this.state.userProfiles) {
        context.commit('SET_USER_PROFILES', await api.getUsersByEmail(email))
      }
    },
    setLoginResolver (context, resolver) {
      context.commit('SET_LOGIN_RESOLVER', resolver)
    },
    reset (context) {
      context.commit('SET_CURRENT_USER_PROFILE', null)
      context.commit('SET_CONTENT_LIBRARY', null)
    },
    authorizeUser (context, user) {
      context.commit('SET_USER_PROFILES', user)
    },
    setTotalClassSessions (context, totalClassSessions) {
      context.commit('SET_TOTAL_CLASS_SESSIONS', totalClassSessions)
    },
    setAccounts (context, accounts) {
      context.commit('SET_ACCOUNTS', accounts)
    },
    setClassTrainingMinutes (context, classTrainingMinutes) {
      context.commit('SET_CLASS_TRAINING_MINUTES', classTrainingMinutes)
    },
    setActiveClassUsers (context, activeClassUsers) {
      context.commit('SET_ACTIVE_CLASS_USERS', activeClassUsers)
    },
    setNewClassUsers (context, newClassUsers) {
      context.commit('SET_NEW_CLASS_USERS', newClassUsers)
    },
    logoutUser (context) {
      context.commit('SET_CURRENT_USER_PROFILE', null)
      context.commit('SET_USER_PROFILES', null)
    },
    setPhoneNumberVerificationId (context, verificationId) {
      context.commit('SET_PHONE_NUMBER_VERIFICATION_ID', verificationId)
    },
    setAuthUserId (context, authUserId) {
      context.commit('SET_AUTH_USER_ID', authUserId)
    },
  },
  getters: {
    getBusy: (state) => state.busy,
    allModules: (state) => state.contentLibrary,
    accounts: (state) => state.accounts,
    getLoginResolver: (state) => state.loginResolver,
    phoneNumberVerificationId: (state) => state.phoneNumberVerificationId,
    totalClassSessions: (state) => state.totalClassSessions,
    activeClassUsers: (state) => state.activeClassUsers,
    classTrainingMinutes: (state) => state.classTrainingMinutes,
    newClassUsers: (state) => state.newClassUsers,
    getAuthUserId: (state) => state.authUserId,
    allPurchasedModules: (state) => {
      return state.contentLibrary ? state.contentLibrary.filter(x => x.purchased) : []
    },
    moduleName: (state, id) => { return state.contentLibrary.find(x => x.id === id).title },
    userProfiles: (state) => state.userProfiles,
    currentUserProfile: (state) => state.currentUserProfile ? state.currentUserProfile : undefined,
    userHasRole: (state) => (role) => {
      if (!state.currentUserProfile) {
        return false
      }
      return state.currentUserProfile.user.roles.includes(role)
    },
    isAuthenticated: (state) => {
      // console.log('get current user profile', state.currentUserProfile)
      return state.currentUserProfile != null
    },
    userName: (state) => {
      if (!state.currentUserProfile) {
        return '?'
      }
      return state.currentUserProfile.account.displayName
    },
  },
})
